/** @format */

import React from "react";
import HeroCardIcon1 from "../../assets/HeroCardIcon1.svg";
import HeroCardIcon2 from "../../assets/HeroCardIcon2.svg";
import HeroCardIcon3 from "../../assets/HeroCardIcon3.svg";
import Card from "./Card";
import CardSection from "./CardSection";

const HeroInnerCards = [
  {
    title: "WORKOUT PROGRAMS",
    summary:
      "Get tailored workout suggestions based on your body and fitness goals.",
    icon: HeroCardIcon1,
  },

  {
    title: "WORKOUT PLANNING",
    summary: `Create schedules for your workouts and get notified when it's time to exercise.`,
    icon: HeroCardIcon2,
  },

  {
    title: "HEALTH CARE",
    summary:
      "Join our community to receive tips and advice on optimising other aspects of your health.",
    icon: HeroCardIcon3,
  },
];

const InnerHeroSection = () => {
  return (
    <CardSection>
      {HeroInnerCards &&
        HeroInnerCards.map((card, key) => (
          <Card
            flex={true}
            key={key}
            title={card.title}
            summary={card.summary}
            icon={card.icon}
          />
        ))}
    </CardSection>
  );
};

export default InnerHeroSection;
